export default "__VITE_ASSET__b$272uf9__"